// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: integrationapp.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "pc.proto.integrationapp";

/**
 * Highest level element, which represents the installation of an "integration app".
 * It combines the IntegrationApp and installation parameters
 */
export interface IntegrationAppInstallation {
  integrationApp?:
    | IntegrationApp
    | undefined;
  /**
   * Version of this installation. This is NOT the version of the app itself.
   * It will be increased if
   * ... the app itself is updated (e.g. brings more resources, registers more webhooks, ...)
   * ... the installation of the app is changed (different parameters)
   */
  appInstallationVersion: number;
}

/**
 * Will contain configuration, e.g. tenant name of CRM of the specific customer
 * message IntegrationAppInstallationParameters {
 * }
 * High level element, which represents "Some integration app". Can be for a pbx or, for example mypascom in the future
 */
export interface IntegrationApp {
  /** Auto-Generated identifier for the App. Will not change even over different versions of it. */
  uuid: string;
  /** Name, given by the partner */
  name: string;
  /** Vendor of the Integration app (e.g. SuperCRM) */
  vendor: string;
  description: string;
  documentationUrl: string;
  websiteUrl: string;
  supportEmail: string;
  privacyPolicyUrl: string;
  iconUrl: string;
  appType?: { $case: "pbxIntegrationApp"; pbxIntegrationApp: PbxIntegrationApp } | undefined;
  apiPermissions: ApiPermissions[];
}

export interface PbxIntegrationApp {
  /**
   * ... introduce webhooks
   * ... introduce configuration
   */
  resources: PbxResource[];
}

export interface PbxLabel {
  /** 050lab_bez */
  name: string;
  /** 050lab_type */
  type: PbxLabel_Type;
  /** 050lab_visible */
  visible: boolean;
}

export enum PbxLabel_Type {
  TYPE_UNKNOWN = 0,
  TYPE_GENERIC = 1,
  TYPE_SKILL = 2,
  UNRECOGNIZED = -1,
}

export function pbxLabel_TypeFromJSON(object: any): PbxLabel_Type {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return PbxLabel_Type.TYPE_UNKNOWN;
    case 1:
    case "TYPE_GENERIC":
      return PbxLabel_Type.TYPE_GENERIC;
    case 2:
    case "TYPE_SKILL":
      return PbxLabel_Type.TYPE_SKILL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PbxLabel_Type.UNRECOGNIZED;
  }
}

export function pbxLabel_TypeToJSON(object: PbxLabel_Type): string {
  switch (object) {
    case PbxLabel_Type.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case PbxLabel_Type.TYPE_GENERIC:
      return "TYPE_GENERIC";
    case PbxLabel_Type.TYPE_SKILL:
      return "TYPE_SKILL";
    case PbxLabel_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Policy, which defines the permissions of the integration app */
export interface ApiPermissions {
  /** One app might have multiple API key / permission sets in the future. We need to identify those */
  identifier: string;
  scopes: string[];
}

export interface PbxResource {
  /**
   * Policy, which defines
   * - whether a resource may be updated by a user or not
   * - what happens to a resource, when the parent integration app is uninstalled
   */
  resourceProperties?: ResourceProperties | undefined;
  resource?: { $case: "label"; label: PbxLabel } | undefined;
}

export interface ResourceProperties {
  /** external identifier, used to reference this resource */
  integrationAppResourceKey: string;
  uninstallPolicy: ResourceProperties_UninstallPolicy;
}

export enum ResourceProperties_UninstallPolicy {
  UNINSTALL_POLICY_UNKNOWN = 0,
  /** UNINSTALL_POLICY_RETAIN - upon removal of the integration app, keep the app scoped resource */
  UNINSTALL_POLICY_RETAIN = 1,
  /** UNINSTALL_POLICY_DELETE - upon removal of the integration app, also delete the app scoped resource */
  UNINSTALL_POLICY_DELETE = 2,
  UNRECOGNIZED = -1,
}

export function resourceProperties_UninstallPolicyFromJSON(object: any): ResourceProperties_UninstallPolicy {
  switch (object) {
    case 0:
    case "UNINSTALL_POLICY_UNKNOWN":
      return ResourceProperties_UninstallPolicy.UNINSTALL_POLICY_UNKNOWN;
    case 1:
    case "UNINSTALL_POLICY_RETAIN":
      return ResourceProperties_UninstallPolicy.UNINSTALL_POLICY_RETAIN;
    case 2:
    case "UNINSTALL_POLICY_DELETE":
      return ResourceProperties_UninstallPolicy.UNINSTALL_POLICY_DELETE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ResourceProperties_UninstallPolicy.UNRECOGNIZED;
  }
}

export function resourceProperties_UninstallPolicyToJSON(object: ResourceProperties_UninstallPolicy): string {
  switch (object) {
    case ResourceProperties_UninstallPolicy.UNINSTALL_POLICY_UNKNOWN:
      return "UNINSTALL_POLICY_UNKNOWN";
    case ResourceProperties_UninstallPolicy.UNINSTALL_POLICY_RETAIN:
      return "UNINSTALL_POLICY_RETAIN";
    case ResourceProperties_UninstallPolicy.UNINSTALL_POLICY_DELETE:
      return "UNINSTALL_POLICY_DELETE";
    case ResourceProperties_UninstallPolicy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseIntegrationAppInstallation(): IntegrationAppInstallation {
  return { integrationApp: undefined, appInstallationVersion: 0 };
}

export const IntegrationAppInstallation: MessageFns<IntegrationAppInstallation> = {
  encode(message: IntegrationAppInstallation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.integrationApp !== undefined) {
      IntegrationApp.encode(message.integrationApp, writer.uint32(10).fork()).join();
    }
    if (message.appInstallationVersion !== 0) {
      writer.uint32(16).uint32(message.appInstallationVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationAppInstallation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationAppInstallation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.integrationApp = IntegrationApp.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.appInstallationVersion = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationAppInstallation {
    return {
      integrationApp: isSet(object.integrationApp) ? IntegrationApp.fromJSON(object.integrationApp) : undefined,
      appInstallationVersion: isSet(object.appInstallationVersion)
        ? globalThis.Number(object.appInstallationVersion)
        : 0,
    };
  },

  toJSON(message: IntegrationAppInstallation): unknown {
    const obj: any = {};
    if (message.integrationApp !== undefined) {
      obj.integrationApp = IntegrationApp.toJSON(message.integrationApp);
    }
    if (message.appInstallationVersion !== 0) {
      obj.appInstallationVersion = Math.round(message.appInstallationVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntegrationAppInstallation>, I>>(base?: I): IntegrationAppInstallation {
    return IntegrationAppInstallation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationAppInstallation>, I>>(object: I): IntegrationAppInstallation {
    const message = createBaseIntegrationAppInstallation();
    message.integrationApp = (object.integrationApp !== undefined && object.integrationApp !== null)
      ? IntegrationApp.fromPartial(object.integrationApp)
      : undefined;
    message.appInstallationVersion = object.appInstallationVersion ?? 0;
    return message;
  },
};

function createBaseIntegrationApp(): IntegrationApp {
  return {
    uuid: "",
    name: "",
    vendor: "",
    description: "",
    documentationUrl: "",
    websiteUrl: "",
    supportEmail: "",
    privacyPolicyUrl: "",
    iconUrl: "",
    appType: undefined,
    apiPermissions: [],
  };
}

export const IntegrationApp: MessageFns<IntegrationApp> = {
  encode(message: IntegrationApp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uuid !== "") {
      writer.uint32(10).string(message.uuid);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.vendor !== "") {
      writer.uint32(26).string(message.vendor);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.documentationUrl !== "") {
      writer.uint32(42).string(message.documentationUrl);
    }
    if (message.websiteUrl !== "") {
      writer.uint32(50).string(message.websiteUrl);
    }
    if (message.supportEmail !== "") {
      writer.uint32(58).string(message.supportEmail);
    }
    if (message.privacyPolicyUrl !== "") {
      writer.uint32(66).string(message.privacyPolicyUrl);
    }
    if (message.iconUrl !== "") {
      writer.uint32(74).string(message.iconUrl);
    }
    switch (message.appType?.$case) {
      case "pbxIntegrationApp":
        PbxIntegrationApp.encode(message.appType.pbxIntegrationApp, writer.uint32(82).fork()).join();
        break;
    }
    for (const v of message.apiPermissions) {
      ApiPermissions.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IntegrationApp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIntegrationApp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vendor = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.documentationUrl = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.websiteUrl = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.supportEmail = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.privacyPolicyUrl = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.iconUrl = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.appType = {
            $case: "pbxIntegrationApp",
            pbxIntegrationApp: PbxIntegrationApp.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.apiPermissions.push(ApiPermissions.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IntegrationApp {
    return {
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      vendor: isSet(object.vendor) ? globalThis.String(object.vendor) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      documentationUrl: isSet(object.documentationUrl) ? globalThis.String(object.documentationUrl) : "",
      websiteUrl: isSet(object.websiteUrl) ? globalThis.String(object.websiteUrl) : "",
      supportEmail: isSet(object.supportEmail) ? globalThis.String(object.supportEmail) : "",
      privacyPolicyUrl: isSet(object.privacyPolicyUrl) ? globalThis.String(object.privacyPolicyUrl) : "",
      iconUrl: isSet(object.iconUrl) ? globalThis.String(object.iconUrl) : "",
      appType: isSet(object.pbxIntegrationApp)
        ? { $case: "pbxIntegrationApp", pbxIntegrationApp: PbxIntegrationApp.fromJSON(object.pbxIntegrationApp) }
        : undefined,
      apiPermissions: globalThis.Array.isArray(object?.apiPermissions)
        ? object.apiPermissions.map((e: any) => ApiPermissions.fromJSON(e))
        : [],
    };
  },

  toJSON(message: IntegrationApp): unknown {
    const obj: any = {};
    if (message.uuid !== "") {
      obj.uuid = message.uuid;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.vendor !== "") {
      obj.vendor = message.vendor;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.documentationUrl !== "") {
      obj.documentationUrl = message.documentationUrl;
    }
    if (message.websiteUrl !== "") {
      obj.websiteUrl = message.websiteUrl;
    }
    if (message.supportEmail !== "") {
      obj.supportEmail = message.supportEmail;
    }
    if (message.privacyPolicyUrl !== "") {
      obj.privacyPolicyUrl = message.privacyPolicyUrl;
    }
    if (message.iconUrl !== "") {
      obj.iconUrl = message.iconUrl;
    }
    if (message.appType?.$case === "pbxIntegrationApp") {
      obj.pbxIntegrationApp = PbxIntegrationApp.toJSON(message.appType.pbxIntegrationApp);
    }
    if (message.apiPermissions?.length) {
      obj.apiPermissions = message.apiPermissions.map((e) => ApiPermissions.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IntegrationApp>, I>>(base?: I): IntegrationApp {
    return IntegrationApp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationApp>, I>>(object: I): IntegrationApp {
    const message = createBaseIntegrationApp();
    message.uuid = object.uuid ?? "";
    message.name = object.name ?? "";
    message.vendor = object.vendor ?? "";
    message.description = object.description ?? "";
    message.documentationUrl = object.documentationUrl ?? "";
    message.websiteUrl = object.websiteUrl ?? "";
    message.supportEmail = object.supportEmail ?? "";
    message.privacyPolicyUrl = object.privacyPolicyUrl ?? "";
    message.iconUrl = object.iconUrl ?? "";
    switch (object.appType?.$case) {
      case "pbxIntegrationApp": {
        if (object.appType?.pbxIntegrationApp !== undefined && object.appType?.pbxIntegrationApp !== null) {
          message.appType = {
            $case: "pbxIntegrationApp",
            pbxIntegrationApp: PbxIntegrationApp.fromPartial(object.appType.pbxIntegrationApp),
          };
        }
        break;
      }
    }
    message.apiPermissions = object.apiPermissions?.map((e) => ApiPermissions.fromPartial(e)) || [];
    return message;
  },
};

function createBasePbxIntegrationApp(): PbxIntegrationApp {
  return { resources: [] };
}

export const PbxIntegrationApp: MessageFns<PbxIntegrationApp> = {
  encode(message: PbxIntegrationApp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.resources) {
      PbxResource.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PbxIntegrationApp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePbxIntegrationApp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.resources.push(PbxResource.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PbxIntegrationApp {
    return {
      resources: globalThis.Array.isArray(object?.resources)
        ? object.resources.map((e: any) => PbxResource.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PbxIntegrationApp): unknown {
    const obj: any = {};
    if (message.resources?.length) {
      obj.resources = message.resources.map((e) => PbxResource.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PbxIntegrationApp>, I>>(base?: I): PbxIntegrationApp {
    return PbxIntegrationApp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PbxIntegrationApp>, I>>(object: I): PbxIntegrationApp {
    const message = createBasePbxIntegrationApp();
    message.resources = object.resources?.map((e) => PbxResource.fromPartial(e)) || [];
    return message;
  },
};

function createBasePbxLabel(): PbxLabel {
  return { name: "", type: 0, visible: false };
}

export const PbxLabel: MessageFns<PbxLabel> = {
  encode(message: PbxLabel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    if (message.visible !== false) {
      writer.uint32(24).bool(message.visible);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PbxLabel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePbxLabel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.visible = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PbxLabel {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.type) ? pbxLabel_TypeFromJSON(object.type) : 0,
      visible: isSet(object.visible) ? globalThis.Boolean(object.visible) : false,
    };
  },

  toJSON(message: PbxLabel): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type !== 0) {
      obj.type = pbxLabel_TypeToJSON(message.type);
    }
    if (message.visible !== false) {
      obj.visible = message.visible;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PbxLabel>, I>>(base?: I): PbxLabel {
    return PbxLabel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PbxLabel>, I>>(object: I): PbxLabel {
    const message = createBasePbxLabel();
    message.name = object.name ?? "";
    message.type = object.type ?? 0;
    message.visible = object.visible ?? false;
    return message;
  },
};

function createBaseApiPermissions(): ApiPermissions {
  return { identifier: "", scopes: [] };
}

export const ApiPermissions: MessageFns<ApiPermissions> = {
  encode(message: ApiPermissions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.identifier !== "") {
      writer.uint32(10).string(message.identifier);
    }
    for (const v of message.scopes) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiPermissions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiPermissions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scopes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiPermissions {
    return {
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : "",
      scopes: globalThis.Array.isArray(object?.scopes) ? object.scopes.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ApiPermissions): unknown {
    const obj: any = {};
    if (message.identifier !== "") {
      obj.identifier = message.identifier;
    }
    if (message.scopes?.length) {
      obj.scopes = message.scopes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ApiPermissions>, I>>(base?: I): ApiPermissions {
    return ApiPermissions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ApiPermissions>, I>>(object: I): ApiPermissions {
    const message = createBaseApiPermissions();
    message.identifier = object.identifier ?? "";
    message.scopes = object.scopes?.map((e) => e) || [];
    return message;
  },
};

function createBasePbxResource(): PbxResource {
  return { resourceProperties: undefined, resource: undefined };
}

export const PbxResource: MessageFns<PbxResource> = {
  encode(message: PbxResource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.resourceProperties !== undefined) {
      ResourceProperties.encode(message.resourceProperties, writer.uint32(18).fork()).join();
    }
    switch (message.resource?.$case) {
      case "label":
        PbxLabel.encode(message.resource.label, writer.uint32(26).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PbxResource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePbxResource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.resourceProperties = ResourceProperties.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.resource = { $case: "label", label: PbxLabel.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PbxResource {
    return {
      resourceProperties: isSet(object.resourceProperties)
        ? ResourceProperties.fromJSON(object.resourceProperties)
        : undefined,
      resource: isSet(object.label) ? { $case: "label", label: PbxLabel.fromJSON(object.label) } : undefined,
    };
  },

  toJSON(message: PbxResource): unknown {
    const obj: any = {};
    if (message.resourceProperties !== undefined) {
      obj.resourceProperties = ResourceProperties.toJSON(message.resourceProperties);
    }
    if (message.resource?.$case === "label") {
      obj.label = PbxLabel.toJSON(message.resource.label);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PbxResource>, I>>(base?: I): PbxResource {
    return PbxResource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PbxResource>, I>>(object: I): PbxResource {
    const message = createBasePbxResource();
    message.resourceProperties = (object.resourceProperties !== undefined && object.resourceProperties !== null)
      ? ResourceProperties.fromPartial(object.resourceProperties)
      : undefined;
    switch (object.resource?.$case) {
      case "label": {
        if (object.resource?.label !== undefined && object.resource?.label !== null) {
          message.resource = { $case: "label", label: PbxLabel.fromPartial(object.resource.label) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseResourceProperties(): ResourceProperties {
  return { integrationAppResourceKey: "", uninstallPolicy: 0 };
}

export const ResourceProperties: MessageFns<ResourceProperties> = {
  encode(message: ResourceProperties, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.integrationAppResourceKey !== "") {
      writer.uint32(10).string(message.integrationAppResourceKey);
    }
    if (message.uninstallPolicy !== 0) {
      writer.uint32(16).int32(message.uninstallPolicy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResourceProperties {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceProperties();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.integrationAppResourceKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.uninstallPolicy = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceProperties {
    return {
      integrationAppResourceKey: isSet(object.integrationAppResourceKey)
        ? globalThis.String(object.integrationAppResourceKey)
        : "",
      uninstallPolicy: isSet(object.uninstallPolicy)
        ? resourceProperties_UninstallPolicyFromJSON(object.uninstallPolicy)
        : 0,
    };
  },

  toJSON(message: ResourceProperties): unknown {
    const obj: any = {};
    if (message.integrationAppResourceKey !== "") {
      obj.integrationAppResourceKey = message.integrationAppResourceKey;
    }
    if (message.uninstallPolicy !== 0) {
      obj.uninstallPolicy = resourceProperties_UninstallPolicyToJSON(message.uninstallPolicy);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceProperties>, I>>(base?: I): ResourceProperties {
    return ResourceProperties.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceProperties>, I>>(object: I): ResourceProperties {
    const message = createBaseResourceProperties();
    message.integrationAppResourceKey = object.integrationAppResourceKey ?? "";
    message.uninstallPolicy = object.uninstallPolicy ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
